import { useCallback, useEffect, useState } from 'react';
import { KeenSliderInstance } from 'keen-slider';

export const useSliderEdges = (instance: KeenSliderInstance | null) => {
    const [isBeginning, setIsBeginning] = useState(true);
    const [isEnd, setIsEnd] = useState(false);
    const [canScroll, setCanScroll] = useState(false);

    const updateEdges = useCallback((slider: KeenSliderInstance) => {
        const details = slider?.track?.details;
        const atStart = details?.rel === 0;
        const atEnd = details?.rel === details?.maxIdx;

        setIsBeginning(atStart);
        setIsEnd(!!atEnd);
    }, []);

    useEffect(() => {
        if (!instance) {
            return;
        }

        const handleResize = () => {
            const details = instance?.track?.details;
            if (!details) {
                return;
            }

            const canScroll = details?.maxIdx > 0;

            setCanScroll(canScroll);
        };

        handleResize();

        window.addEventListener('resize', handleResize, { passive: true });

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [instance, updateEdges]);

    return { isBeginning, isEnd, canScroll, updateEdges };
};
